import { Order } from "apps/orders/models/order";
// import { Subscriber } from "./subscriber";


export const subEndReasons = [
    {value: '', label: '-Seleziona motivazione-'},
    {value: 'transfer', label: 'Trasferimento'},
    {value: 'debt', label: 'Morosità'},
    {value: 'death', label: 'Morte'},
    {value: 'strike_off', label: 'Radiazione'},
    {value: 'renounce', label: 'Rinuncia'},
    {value: 'lost_citizenship', label: 'Perdita cittadinanza italiana'},
    {value: 'transfer_abroad', label: 'Trasferimento all\'estero'},
    {value: 'other', label: 'Altro'},
    {value: 'order_merge', label: 'Accorpamento ordini'},
];

export class Subscription {

    constructor(data) {
        this.id = data.id;
        this.n_sub = data.n_sub;
        this.order = new Order(data.order_data);
        // this.subscriber = new Subscriber(data.subscriber_data);
        this.subscriber = data.subscriber;
        this.state = data.state;
        this.date_sub_start = data.date_sub_start;
        this.date_sub_end = data.date_sub_end;
        this.sub_end_notes = data.sub_end_notes;
        this.sub_end_reasons = data.sub_end_reasons;
        this.n_dossier = data.n_dossier;
        this.n_card = data.n_card;
        this.n_position = data.n_position;
        this.n_delibera = data.n_delibera;
    }

    getSubEndReasonLabel() {
        const reason = subEndReasons.find(reason => reason.value === this.sub_end_reasons);
        return reason ? reason.label : null;
    }
}